import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { determineStateData, isStateRequiredCountry } from 'commons/utils'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const State = () => {
  const { control } = useFormContext<SarEdit>()
  const country = useWatch({ control, name: 'institutionContactInfo.country' })
  const state = useWatch({ control, name: 'institutionContactInfo.state' })
  const states = determineStateData(country)

  // disable input if it has one option and it's selected
  const isDisabled = states.length === 1 && state === states[0].value

  return (
    <Controller
      name="institutionContactInfo.state"
      control={control}
      rules={{
        validate: (value) => (!isStateRequiredCountry(country) || !!value ? undefined : '"84. State" required')
      }}
      render={({ field }) => (
        <FF2
          required={isStateRequiredCountry(country)}
          label="84. State"
          field={field}
          input={(props) => (
            <Select
              {...props}
              searchable
              disabled={isDisabled}
              data={states}
              data-qa="84. State"
              options-data-qa="84. State option"
            />
          )}
        />
      )}
    />
  )
}
